import { getBrowserHtmlContent } from './browser-utils';
import { isFeatureEnable } from './features-enabling';
import { updateQueryStringParameters } from './helpers';

export function canInstallShortcut(
  config: AdConfig,
  isAfterBrowser: boolean = false
) {
  const configIcon: AdConfigIcon = config.icon as AdConfigIcon;
  const isEnabledAfterBrowser =
    config.icon &&
    configIcon.isAllowedAfterBrowser === true &&
    isFeatureEnable('installIconAfterBrowser') &&
    config.browser === 'browser';

  if (
    (!isAfterBrowser && isFeatureEnable('installIcon')) ||
    (isAfterBrowser && isEnabledAfterBrowser) ||
    configIcon.forceInstall
  ) {
    return (
      Boolean(window.mraid) &&
      Boolean(window.mraid.ogyCreateShortcut) &&
      Boolean(configIcon) &&
      Boolean(configIcon.useIcon) &&
      Boolean(configIcon.url) &&
      Boolean(configIcon.name) &&
      Boolean(configIcon.identifier)
    );
  }
  return false;
}

interface InstallShortcutOptions {
  forceRedirectUrl?: string;
  isAfterBrowser?: boolean;
  forceResolve?: boolean;
}

export function installShortcut(
  adOptions: FormatOptions,
  config: AdConfig,
  {
    forceRedirectUrl,
    isAfterBrowser = false,
    forceResolve = false
  }: InstallShortcutOptions = {}
): Promise<any> {
  if (
    !isFeatureEnable('installIcon') &&
    !isFeatureEnable('installIconAfterBrowser')
  ) {
    return Promise.resolve();
  }

  return new Promise<void>((resolve, reject) => {
    if (!canInstallShortcut(config, isAfterBrowser)) {
      return reject(new Error('Cannot create shortcut, missing parameters'));
    }

    const clickUrl = isAfterBrowser ? config.url : config.clickUrl;

    const iconClickUrl = updateQueryStringParameters(clickUrl, {
      force_redirect: forceRedirectUrl ? forceRedirectUrl : '',
      source: 'icon'
    });

    const configIcon: AdConfigIcon = config.icon as AdConfigIcon;

    const iconProperties = {
      content: getBrowserHtmlContent(adOptions, iconClickUrl),
      icon: configIcon.url,
      id: configIcon.identifier,
      name: configIcon.name
    };

    if (window.mraid.ogyCreateShortcut) {
      window.mraid.ogyCreateShortcut(iconProperties, (err, res) => {
        if (err) {
          return reject(err);
        }
        // Yet this is broken, we never receive a callback from SDK
        resolve(res);
      });
    }

    if (forceResolve) {
      resolve();
    }
  });
}
